import { Controller } from '@hotwired/stimulus';
import { postRequest } from '../src/utils';

// Connects to data-controller="smart-debit"
// Used in 2 places: enrol form slide 3 (including '_text' form component) and parent payment infos form
// Purpose: check direct debit information with smart debit api and show/hide resulting errors/success messsage
export default class extends Controller {
  static targets = [
    'input', // all inputs
    'accountEmail',
    'accountNumber',
    'sortCode',
    'accountName',
    'firstName',
    'lastName',
    'errors', // errors div
    'submit', // submit btn
    'successContainer', // success message container below form
    'errorsContainer', // error messages container below form
  ];
  connect() {
    // console.log('smart debit controller connected');
  }

  async validate(event) {
    console.log('Validate method called', event);
    try {
      let allFilled = this.inputTargets.every((input) => input.value);
      console.log('All fields filled:', allFilled);
      console.log('Sort code length:', this.sortCodeTarget.value.length);

      if (allFilled && this.sortCodeTarget.value.length == 6) {
        console.log('Calling validateWithApi');
        let result = await this.validateWithApi();
        console.log('API validation result:', result);

        if (result === true) {
          console.log('Validation successful, calling allowProceed');
          this.allowProceed();
        } else {
          console.log('Validation failed, calling showErrors');
          this.showErrors(result);
        }
      } else {
        console.log('Not all fields filled or sort code length incorrect');
      }
    } catch (error) {
      console.error('Detailed error in validate method:', error);
      console.error('Error stack:', error.stack);
      this.showErrors('An unexpected error occurred. Please check the console for details.');
    }
  }

  async validateWithApi() {
    // post request to smart debit api with payment info as body
    let body = {
      payment_info: {
        account_number: this.accountNumberTarget.value,
        account_name: this.accountNameTarget.value,
        account_email: this.accountEmailTarget.value,
        sort_code: this.sortCodeTarget.value,
        first_name: this.firstNameTarget.value,
        last_name: this.lastNameTarget.value,
      },
    };
    try {
      let response = await postRequest('/api/v1/payment_infos/validate_with_smart_debit', body);
      let data = await response.json();
      // console.log('data', data);
      return data.result;
    } catch (error) {
      throw error;
    }
  }
  showErrors(errors) {
    console.log('errors', errors);
    // clear errors
    this.errorsTarget.innerHTML = '';
    // if multiple errors
    if (Array.isArray(errors)) {
      errors.forEach((error) => {
        this.errorsTarget.innerHTML += `<div>${error}</div>`;
      });
    } else {
      // if one error
      this.errorsTarget.innerHTML += `<div>${errors}</div>`;
    }
    // show errors and make text red
    this.errorsTarget.classList.add('text-red-500');
    this.errorsTarget.classList.remove('text-green-500');
    this.errorsTarget.classList.remove('hidden');
    // disable submit button
    this.submitTarget.setAttribute('disabled', true);
    // show errors container target if exists
    if (this.errorsContainerTarget) this.errorsContainerTarget.classList.remove('hidden');
    // show success container target if exists
    if (this.successContainerTarget) this.successContainerTarget.classList.add('hidden');
  }

  allowProceed() {
    // upon succesful api result, allow user to proceed
    // make show errors text as 'success' and make it green
    this.errorsTarget.classList.add('text-green-500');
    this.errorsTarget.classList.remove('text-red-500', 'hidden');
    this.errorsTarget.innerText = 'Success';
    // enable the submit button
    this.submitTarget.removeAttribute('disabled');
    // hide errors container and show success container (if exist)
    if (this.errorsContainerTarget) this.errorsContainerTarget.classList.add('hidden');
    if (this.successContainerTarget) this.successContainerTarget.classList.remove('hidden');
  }
}
